<template>
<b-row class="wizard-step">
  <b-col>
    <b-row v-if="title" class="section-title">
      <h3>{{title}}</h3>
    </b-row>
    <b-row class="section-content-container">
      <!--! Changed -->
      <b-col v-if="!readOnly && items.length < 2" class="section-intro text-center">
        <slot name="instruction">Click the box to indicate compliance</slot>
      </b-col>
      <b-col v-if="!readOnly && items.length > 1" class="section-intro text-center">
        <slot name="instructions">Click each box to indicate compliance</slot>
      </b-col>
      <b-col class="px-0 accept-btns">
        <button type="button"
                @click="toggleAccept(index)"
                class="section-radio-btn text-left"
                :class="[item.accepted ? 'checked' : '', btnClasses, readOnly ? 'read-only' : '']"
                v-for="(item, index) in items"
                :title="item.title ? item.title : null"
                :disabled="readOnly"
                v-bind:key="'btn-item-' + type + '-' + index">
          <slot name="item" v-bind:item="item">
            <span v-html="item.text"></span>
          </slot>
        </button>
      </b-col>
      <slot name="extra"></slot>
    </b-row>
  </b-col>
</b-row>
</template>

<style lang="scss">
  ul {
    padding-bottom: 0px;
    margin-bottom: 1px;
  }
</style>

<script>

export default {
  name: 'AcceptSection',
  props: {
    title: String,
    type: String,
    items: Array,
    readOnly: {
      type: Boolean,
      default: false,
    },
    btnClasses: {
      type: String,
      default: 'accept-full',
    },
  },
  methods: {
    toggleAccept(index) {
      this.$emit('accept-toggle', this.type, index);
    },
  },
};
</script>
